<template>
    <div class="taskbar no-print" :class="{
        'is-hidden': hidden
    }">
        <div class="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default Vue.extend({
  props: {
    isHidden: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hidden: this.isHidden
    };
  },
  updated() {
    Vue.nextTick(() => {
      this.$root.$el.style.marginBottom = this.$el.offsetHeight + "px";
    });
  },
  methods: {
    hide(hidden = true) {
      this.hidden = hidden;
    },
    show() {
      this.hide(false);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Taskbar.vue